import { attr } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validateNumber,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

/**
 * The PHQ-9 score
 * It's a 9-item measure
 */
export default class PhqNineDeclaredJournalEvent extends JournalEvent {
  static override type = "phq-nine-declared-journal-event";

  /**
   * An array containing a score corresponding to a numeroted question
   */
  @attr({
    defaultValue() {
      return [];
    }
  })
  declare items: number[];

  /**
   * The total score.
   * The total must always be set.
   * It can be set directly, without setting the other scores.
   * This may happen if the medic passes the scale outside the Platform
   * but still wants to track the final score.
   */
  @attr("number") declare total: number;

  static override validations(intl: IntlService) {
    return {
      total: [
        validatePresence({
          presence: true,
          description: intl.t(
            "validations.phq-nine-declared-journal-event.total"
          )
        }),
        validateNumber({
          integer: true,
          description: intl.t(
            "validations.phq-nine-declared-journal-event.total"
          )
        })
      ],
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.phq-nine-declared-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "phq-nine-declared-journal-event": PhqNineDeclaredJournalEvent;
  }
}
